// Generated by ReScript, PLEASE EDIT WITH CARE


function getLoginFormStateDefault(param) {
  return {
          login_form_input: undefined,
          is_disabled: false
        };
}

export {
  getLoginFormStateDefault ,
}
/* No side effect */
